<template>
    <div id="today-event" class="calendar-today-wrapper">
        <a-popover id="calendarTodayEvents" placement="bottom" trigger="hover" overlayClassName="calendarTodayEvents">
            <template slot="content" v-if="todayEvents.length > 0">
                <div class="add-event-popover">
                    <div class="material-icons add-event-btn" @click="openAddEvent">add</div>
                    <div>Add Event</div>
                </div>
                <div class="calendar-event event-popover" v-for="todayEvent in todayEvents" :key="todayEvent._id">
                    <div class="event-summary" @click="goCalendarPage(todayEvent)">{{ todayEvent.summary }}</div>
                    <div class="event-date" @click="goCalendarPage(todayEvent)">
                        <div>
                            {{ getEventTime(todayEvent.start, todayEvent.isAllDay) }} -
                            {{ getEventTime(todayEvent.end, todayEvent.isAllDay) }}
                        </div>
                    </div>
                </div>
            </template>

            <div class="calendar-today-button" @click="goCalendarPage">
                <div class="calendar-icon-wrapper">
                    <CalendarIcon />
                </div>
                <div class="calendar-date-info">
                    <span class="calendar-day-name">{{ getFullDayString() }}</span>
                    <span class="calendar-day-number">{{ new Date().getDate() }}</span>
                </div>
                <div class="calendar-event-count" v-if="todayEvents.length > 0">
                    <div class="material-icons">event_note</div>
                    <span>{{ todayEvents.length }}</span>
                </div>
                <div class="calendar-add-btn" @click.stop="openAddEvent">
                    <div class="material-icons">add</div>
                </div>
            </div>
        </a-popover>

        <CreateEventModal v-if="openCalendarAddEventModal" @close="openCalendarAddEventModal = false" />
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { log2 } from "../../../../utils/log2";
import moment from "moment-timezone";
import CONFIG from "../../../../config/config";
import CreateEventModal from "./CreateEventModal";
import _ from "lodash";
import { PERMISSION_TYPES } from "../../../../language/permissionTypes";
import CalendarIcon from "../../../../components/svg/appSwitcherIcon/CalendarIcon.vue";

moment.locale("tr");
const log = log2("TodayEvent");
export default {
    name: "TodayEvent",
    components: {
        CreateEventModal,
        CalendarIcon
    },
    props: {},
    data() {
        return {
            todayEvents: [],
            openCalendarAddEventModal: false,
            CONFIG,
            calendarSetting: {},
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            newEvent: (state) => state.calendar.newEvent,
            updatedEvent: (state) => state.calendar.updatedEvent,
            deleteEvent: (state) => state.calendar.deleteEvent,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapActions({
            getTodayEvents: "calendar/getTodayEvents",
            getCalendarSettings: "calendar/getCalendarSettings",
        }),
        ...mapMutations({}),
        getSelectedTimezone() {
            return this.calendarSetting?.timezone || "Europe/Istanbul";
        },
        openAddEvent() {
            if (this.checkPermission(PERMISSION_TYPES["calendar.create"].tr.name)) {
                this.openCalendarAddEventModal = true;
            } else {
                this.$message.error("Bu işlem için izniniz yok");
            }
        },
        getEventTime(date, isAllDay) {
            console.log("getEventTime date", { date, isAllDay });
            if (isAllDay) return moment(date).format("L");
            else return moment(date).format("HH:mm");
        },
        getDayString() {
            return moment().format("dd");
        },
        getFullDayString() {
            return moment().format("dddd");
        },
        goCalendarPage(event = null) {
            if (!!event) this.$router.push(`/calendar/d/${moment().format().split("T")[0]}/${event._id}`);
            else this.$router.push(`/calendar/d/${moment().format().split("T")[0]}`);
        },
    },
    async mounted() {
        this.$feature.beforeFetchCalendar(() => {
            this.getTodayEvents(this.user._id).then((res) => {
                console.log("getTodayEvents..", res);
                this.todayEvents = res;
            });
            this.getCalendarSettings({ userId: this.user._id }).then((res) => {
                this.calendarSetting = res;
            });
        });
    },
    watch: {
        deleteEvent(value) {
            console.log("today deleteEvent watch", value);
            if (this.todayEvents.find((event) => event._id === value._id)) {
                this.todayEvents = this.todayEvents.filter((event) => event._id !== value._id);
            }
        },
        newEvent(values) {
            console.log("TodayEvent newEvent", values);
            values = _.isArray(values) ? values : [values];
            const timezone = this.getSelectedTimezone();

            values.map((val) => {
                if (
                    (val &&
                        val.start >= moment().tz(timezone).format() &&
                        val.start <= moment().tz(timezone).endOf("day").format()) ||
                    (val.start <= moment().tz(timezone).format() && val.end >= moment().tz(timezone).format())
                ) {
                    let dates = [val, ...this.todayEvents];
                    dates.sort(function (a, b) {
                        return new Date(a.start) - new Date(b.start);
                    });
                    this.todayEvents = dates;
                }
            });
        },
        updatedEvent(values) {
            console.log("TodayEvent updatedEvent", values);
            const ids = this.todayEvents.map((event) => event._id);
            values = _.isArray(values) ? values : [values];
            const timezone = this.getSelectedTimezone();
            values.map((val) => {
                if (
                    (val &&
                        val.start >= moment().tz(timezone).format() &&
                        val.start <= moment().tz(timezone).endOf("day").format()) ||
                    (val.start <= moment().tz(timezone).format() && val.end >= moment().tz(timezone).format())
                ) {
                    console.log("today event if");
                    if (!ids.includes(val._id)) {
                        let dates = [val, ...this.todayEvents];
                        dates.sort(function (a, b) {
                            return new Date(a.start) - new Date(b.start);
                        });
                        this.todayEvents = dates;
                    }
                } else {
                    console.log("today event else ");
                    this.todayEvents = this.todayEvents.filter((event) => event._id !== val._id);
                }
            });
        },
    },
};
</script>

<style lang="scss">
.calendarTodayEvents {
    .ant-popover-inner-content {
        padding: 0 !important;
        box-shadow: 0 3px 6px #00000080;
    }
}
</style>

<style lang="scss" scoped>
.calendar-today-wrapper {
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
}

.calendar-today-button {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    min-width: 128px !important;
    height: 32px !important;
    padding: 5px 8px !important;
    background: linear-gradient(135deg, #f0f4f8 0%, #e8f0f7 100%) !important;
    border: 1px solid #d5dee6 !important;
    border-radius: 16px !important;
    cursor: pointer !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    gap: 6px !important;
    box-sizing: border-box !important;
    user-select: none !important;

    &:hover {
        background: linear-gradient(135deg, #e8f0f7 0%, #dde7f0 100%) !important;
        border-color: #b8c5d3 !important;
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
    }

    &:active {
        transform: translateY(0px) !important;
    }

    .calendar-icon-wrapper {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 14px !important;
        height: 14px !important;
        color: #6b7c93 !important;
        flex-shrink: 0 !important;

        svg {
            width: 14px !important;
            height: 14px !important;
        }
    }

    .calendar-date-info {
        display: flex !important;
        align-items: center !important;
        gap: 4px !important;
        flex: 1 !important;
        min-width: 0 !important;

        .calendar-day-name {
            font-size: 10px !important;
            font-weight: 500 !important;
            color: #5a6c7d !important;
            white-space: nowrap !important;
            text-transform: capitalize !important;
        }

        .calendar-day-number {
            font-size: 11px !important;
            font-weight: 700 !important;
            color: #2c3e50 !important;
            white-space: nowrap !important;
        }
    }

    .calendar-event-count {
        display: flex !important;
        align-items: center !important;
        gap: 2px !important;
        padding: 2px 5px !important;
        background: rgba(255, 255, 255, 0.6) !important;
        border-radius: 6px !important;
        flex-shrink: 0 !important;

        .material-icons {
            font-size: 11px !important;
            color: #4a90e2 !important;
        }

        span {
            font-size: 9px !important;
            font-weight: 600 !important;
            color: #4a90e2 !important;
        }
    }

    .calendar-add-btn {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 16px !important;
        height: 16px !important;
        background: rgba(74, 144, 226, 0.1) !important;
        border-radius: 50% !important;
        cursor: pointer !important;
        transition: all 0.2s ease !important;
        flex-shrink: 0 !important;

        .material-icons {
            font-size: 13px !important;
            color: #4a90e2 !important;
        }

        &:hover {
            background: rgba(74, 144, 226, 0.2) !important;
            transform: scale(1.1) !important;

            .material-icons {
                color: #357abd !important;
            }
        }
    }
}

.event-date {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    margin-top: -3px;

    .add-event-btn {
        font-size: 20px;

        &:hover {
            color: #448aff;
        }
    }
}

.add-event-popover {
    border-bottom: 1px solid grey;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.calendar-event {
    width: 120px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.header-event {
        margin-left: 15px;
    }

    &.event-popover {
        padding: 5px 10px;
        width: 150px;
    }

    &:hover {
        background-color: #f3f3f3;
    }

    .event-summary {
        font-weight: 700;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: -2px;
    }
}

#today-event {
    height: 32px !important;
}
</style>
